import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "fileFilled"
const FileFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M14.25 1.489V5.989C14.25 7.232 15.257 8.239 16.5 8.239H21V20.239C21 21.482 19.993 22.489 18.75 22.489H5.25C4.007 22.489 3 21.482 3 20.239V3.739Q3.002 3.415 3.089 3.117L3.099 3.08Q3.116 3.023 3.138 2.968 3.152 2.923 3.17 2.879 3.19 2.83 3.217 2.78 3.239 2.728 3.264 2.678L3.308 2.606Q3.34 2.55 3.376 2.495 3.402 2.457 3.428 2.42 3.462 2.373 3.498 2.328 3.528 2.29 3.56 2.257 3.602 2.208 3.646 2.162L3.706 2.104 3.794 2.024Q3.838 1.988 3.884 1.954 3.92 1.923 3.96 1.895 4.008 1.864 4.057 1.833 4.1 1.805 4.147 1.78L4.235 1.732Q4.284 1.707 4.333 1.685 4.386 1.662 4.441 1.64L4.534 1.606 4.644 1.573Q4.694 1.56 4.744 1.548 4.99 1.49 5.25 1.489z" />
          <path d="M19.616 6.739H16.5C16.086 6.739 15.75 6.403 15.75 5.989V2.551z" />
        </svg>
      }
    </span>
  )
}
export default FileFilledIcon
